import React from 'react';
import styled from 'styled-components';
import Layout from '../shared/layout/Layout';
import Header from '../shared/layout/header/Header';
import { useState } from 'react';
import { useEffect } from 'react';
import { getStrapiCompany } from '../redux/api/blog';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import MessageModal from '../components/blog/MessageModal';
import { getOnePopUpSlide } from '../redux/api/announcements';
import EditPopUpForm from '../components/announcementsAndNews/EditPopUpForm';

const EditPopUp = () => {
    const { id } = useParams();
    const ondemandId = useSelector(state => state.user.user.id);

    //STATES
    const [popUpToEdit, setPopUpToEdit] = useState(null);
    const [editedPopUp, setEditedPopUp] = useState(null); 
    const [publishedPopUP, setPublishedPopUp] = useState(null);
    const [strapiId, setStrapiId] = useState(null); //la generación de pop up se vincula por id de strapi del ondemand, el cual se consulta por repo_id

    const [messageOpen, setMessageOpen] = useState(false);
    const [contentMessage, setContentMessage] = useState(null);

    //EFFECTS
    useEffect(() => {
        if (id !== null) {
            getPopUp(id);
        }
    }, [id]);

    useEffect(() => {
        if (strapiId === null) {
            getStrapiId(ondemandId);
        }
    }, []);

    useEffect(() => {
        if (!!editedPopUp) {
            setMessageOpen(true);
            setContentMessage({
                message: '¡Pop Up guardado!',
                image: '/images/saved_article.svg',
                subtitle: 'El Pop Up se guardó como borrador',
            });
            getPopUp(id);
        }
    }, [editedPopUp]);

    useEffect(() => {
        if (!!publishedPopUP) {
            setMessageOpen(true);
            setContentMessage({
                message: '¡Pop Up publicado!',
                image: '/images/published_article.svg',
                subtitle: 'El Pop Up fue publicado con éxito',
            });
            getPopUp(id);
        }
    }, [publishedPopUP]);

    //FUNCTIONS
    const getPopUp = async id => {
        let req = await getOnePopUpSlide(id);
        // console.log('req', req);
        if (!!req) {
            setPopUpToEdit(req.data.attributes);
        }
    };

    const getStrapiId = async id => {
        let req = await getStrapiCompany(id);
        if (!!req) {
            setStrapiId(req.data[0].id);
        }
    };

    const handlePublished = PopUp => {
        setEditedPopUp(null);
        setPublishedPopUp(PopUp);
    };

    const handleUpdate = PopUp => {
        setEditedPopUp(PopUp);
    };

    const handleClose = () => {
        // console.log('handleClose');
        setMessageOpen(false);
        setContentMessage(null);
    };

    //RETURN
    return (
        <>
            <Layout header={<Header route="Edición de Pop Up" />}>
                <HeaderWrapper>
                    {!!popUpToEdit && (
                        <EditPopUpForm
                            popUpToEdit={popUpToEdit}
                            strapiId={strapiId}
                            artId={id}
                            handleUpdate={handleUpdate}
                            handlePublished={handlePublished}
                        />
                    )}
                </HeaderWrapper>
            </Layout>
            <MessageModal
                isOpen={messageOpen}
                handleClose={handleClose}
                message={contentMessage?.message}
                image={contentMessage?.image}
                subtitle={contentMessage?.subtitle}
            />
        </>
    );
};

export default EditPopUp;

const HeaderWrapper = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    padding: 1rem;
    gap: 1rem;
    align-items: center;
    column-gap: 1.5rem;
    position: relative;
`;
